import React from 'react';
import './Hero.css';

const Hero = () => {
  const scrollToDemo = () => {
    const element = document.getElementById('demo');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToPartners = () => {
    const element = document.getElementById('partners');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero">
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">
            نبني <span className="gradient-text">ألعاباً اجتماعية</span> تجمع الناس
          </h1>
          <p className="hero-subtitle">
            نحن نطور ألعاباً تفاعلية ممتعة تربط العلامات التجارية بجمهورها بطريقة مبتكرة ومسلية
          </p>
          <div className="hero-buttons">
            <button onClick={scrollToDemo} className="btn btn-primary">جرب اللعبة الآن</button>
            <button onClick={scrollToPartners} className="btn btn-secondary">كن شريكاً</button>
          </div>
        </div>
        <div className="hero-visual">
          <div className="floating-card card-1">🎯</div>
          <div className="floating-card card-2">🏆</div>
          <div className="floating-card card-3">⚡</div>
          <div className="floating-card card-4">🎪</div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
